import React from 'react'
import './About_Banner_Component.css'
import RedRoundBtn from '../../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn'

const About_Banner_Component = (props) => {
    return (
        <section className='About_Banner_Component'>

            <div className='container-fluid p-0'>
                <div className='banner_img_holder'>
                    <img src={props?.img} className='banner_img' alt="Banner" />
                </div>
            </div>

            <div className='container'>
                <div className='banner_text_holder'>

                    <div className=''>
                        <p className='banner_heading'>{props?.title}</p>

                        <p className='subtext1'>{props?.subtext1}</p>
                        <p className='subtext2'>{props?.subtext2}</p>
                    </div>
                    {props?.showBtn && (
                        <div className='btn_holder'>
                            <RedRoundBtn btn_name="Get a Loan" />
                        </div>
                    )}

                </div>
            </div>





        </section>
    )
}

export default About_Banner_Component
